document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector('.btn-mobile');
  const nav = document.querySelector('.nav-global');
  const html = document.documentElement;

  // Calcula a largura da scrollbar do menu mobile
  setTimeout(() => { 
    let l=window.innerWidth-document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--scrollbar-width",l+"px")
  }, 100);

  button.addEventListener('click', function () {
    button.classList.toggle('open');
    nav.classList.toggle('open');
    html.classList.toggle('open');
  });
});
